/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PopoverWrapper from 'react-simple-popover';
import getStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Header from '../../elements/Header';
import Button from '../../elements/Button';
import Box from '../../elements/Box';
import Icon from '../../elements/Icon';

// Hacer una refactorización del código y usar el overlay directo
// https://www.npmjs.com/package/react-simple-popover
// https://github.com/dbtek/react-popover/blob/master/src/Popover.js
// https://www.npmjs.com/package/react-overlays
class Popover extends PureComponent {
  constructor(props) {
    super(props);
    props.focusReferences(this);
    this.state = {
      open: props.open,
      random: `popover_${new Date().getTime()}_${Math.random().toString().replace('.', '')}`
    };

    this.keyCode = {
      down: 40,
      enter: 13,
      tab: 9,
      escape: 27
    };
    this.closePopover = this.closePopover.bind(this);
    this.openPopover = this.openPopover.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onSaveAction = this.onSaveAction.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.controlled && props.open !== state.open) {
      return { open: props.open };
    }
    return null;
  }

  onBlur(event) {
    if (
      (event.shiftKey === false && event.keyCode === this.keyCode.tab) ||
      event.keyCode === this.keyCode.enter
    ) {
      this.setState({ open: false });
    }
  }

  onSaveAction() {
    const { onSave } = this.props;
    this.closePopover();
    onSave();
  }

  onKeyDown(event) {
    const { controlled, openPressArrowDown } = this.props;
    if (event.keyCode === this.keyCode.down && openPressArrowDown) {
      this.setState({ open: true });
    }
    if (event.shiftKey && event.keyCode === this.keyCode.tab && !controlled) {
      this.setState({ open: false });
    }
    if (event.keyCode === this.keyCode.enter && !controlled) {
      const { onSave } = this.props;
      this.closePopover();
      onSave();
    }
  }

  openPopover() {
    const { onOpen } = this.props;
    this.setState({ open: true });
    onOpen();
  }

  closePopover(e = undefined) {
    const { onClose } = this.props;
    this.setState({ open: false });
    onClose(e);
  }

  render() {
    const { open, random } = this.state;
    const {
      children,
      placement,
      element,
      title,
      showTitle,
      showClose,
      minWidth,
      titleItem,
      buttonClose,
      align,
      hideWithOutsideClick,
      controlled,
      showArrow
    } = this.props;
    const { translate, direction, theme } = this.context;

    const arrow = {
      height: 12,
      borderWidth: 1,
      borderColor: '@palette:borderColor',
      offset: '8%',
      verticalOffset: 5, // Move the arrow up and down, hopefully you won't need to use it, except if your CSS in messing up with you
      ...this.props.arrow
    };

    let arrowStyles;
    // A common hack to create triangles in CSS (https://css-tricks.com/snippets/css/css-triangle/)
    // We use generated content in order to create this decoration.
    if (showArrow) {
      const halfWidth = arrow.width ? arrow.width / 2 : arrow.height;
      const arrowCommonStyles = {
        content: '""',
        display: 'block',
        position: 'absolute',
        width: 0,
        height: 0,
        'border-style': 'solid',
        top: `${-arrow.height - arrow.borderWidth + arrow.verticalOffset + 1}px`,
        left: arrow.offset,
        'border-color': `transparent`,
        'border-bottom-color': arrow.borderColor,
        'border-width': `0 ${halfWidth}px ${arrow.height}px ${halfWidth}px`
      };
      arrowStyles = {
        '::after': {
          ...arrowCommonStyles,
          'border-bottom-color': 'white',
          top: `${-arrow.height + arrow.borderWidth / 2 + arrow.verticalOffset}px`
        }
      };
      // If we want the arrow to have borders we need to actually have two
      // triangles. This is because the hack relies on borders to simulate
      // the triangle shape (no free lunch, right?).
      if (arrow.borderWidth) {
        arrowStyles['::before'] = arrowCommonStyles;
      }
    }

    const [className, style] = getStyles(
      {
        ...this.props,
        'cmp-styles': {
          ...arrowStyles,
          // eslint-disable-next-line react/prop-types
          ...this.props['cmp-styles']
        }
      },
      { direction, theme }
    );
    const styles = Object.assign({}, style, { width: `${minWidth}`, color: 'inherit' });
    let classNamePopOver =
      (align === 'left' && direction === 'ltr') || (align === 'right' && direction === 'rtl')
        ? `fr-popover-left direction-${direction}`
        : `fr-popover-right direction-${direction}`;
    return (
      <div
        className={`fr-popover ${classNamePopOver}`}
        {...this.props.containerProps}
        ref={this.props.containerRef}
      >
        <div ref={random} style={{ display: 'inline' }}>
          {React.cloneElement(element, {
            ...element.props,
            onClick: controlled ? element.onClick : () => this.openPopover(),
            onKeyDown: this.onKeyDown
          })}
        </div>
        <PopoverWrapper
          placement={placement}
          container={this}
          show={open}
          hideWithOutsideClick={hideWithOutsideClick}
          // eslint-disable-next-line react/no-string-refs
          target={this.refs[random]}
          onHide={(e) => {
            if (this.props.onClickOutPopup && e.type !== 'keyup') {
              this.props.onClickOutPopup();
            }
            this.closePopover();
          }}
          containerStyle={{
            borderColor: 'black',
            zIndex: 10,
            marginTop: showArrow ? arrow.height : undefined
          }}
          style={styles}
        >
          <div className={`content-popover ${className}`}>
            {showTitle && title && (
              <div className="popover-title">
                <Header type="h3" className="popover-header" {...titleItem}>
                  <b>{title}</b>
                </Header>
              </div>
            )}
            {showClose && (
              <Button
                {...buttonClose}
                color="light"
                ariaLabel={translate('cmp-popover-close', 'Close')}
                className="popover-close"
                onClick={this.closePopover}
                floatRight
              >
                <Icon icon="close" />
              </Button>
            )}
            <Box className="popover-body">{children}</Box>
          </div>
        </PopoverWrapper>
      </div>
    );
  }
}

Popover.propTypes = {
  /**
   * Title of Popover
   */
  title: PropTypes.string,
  /**
   * Props of title item
   */
  titleItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of button close
   */
  buttonClose: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of button done
   */
  buttonDone: PropTypes.objectOf(PropTypes.any),
  /**
   * Show title of popover.
   */
  showTitle: PropTypes.bool,
  /**
   * Show button icon in the popover
   */
  showClose: PropTypes.bool,
  /**
   * Show button done in the popover
   */
  showDone: PropTypes.bool,
  /**
   * Position of arrow. Posibles values are: right, top, left, bottom
   */
  placement: PropTypes.string,
  /**
   * Elements to show inside of Links
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /**
   * hide the component when the mouse click outside
   */
  hideWithOutsideClick: PropTypes.bool,
  /**
   * control when the popover is visible from outside
   */
  controlled: PropTypes.bool,
  element: PropTypes.node,
  minWidth: PropTypes.string,
  open: PropTypes.bool,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onClickOutPopup: PropTypes.func,
  onOpen: PropTypes.func,
  focusReferences: PropTypes.func,
  align: PropTypes.arrayOf(PropTypes.oneOf(['left', 'right'])),
  showArrow: PropTypes.bool,
  openPressArrowDown: PropTypes.bool,
  arrow: PropTypes.objectOf(PropTypes.any),
  containerProps: PropTypes.object,
  containerRef: PropTypes.any
};

Popover.defaultProps = {
  title: '',
  titleItem: {},
  buttonClose: {},
  openPressArrowDown: true,
  buttonDone: {
    width: '100',
    color: 'primary'
  },
  containerProps: {},
  showTitle: true,
  showClose: false,
  showDone: false,
  showArrow: false,
  minWidth: '400px',
  placement: 'bottom',
  children: null,
  element: null,
  open: false,
  onSave: () => {},
  onClose: () => {},
  onOpen: () => {},
  focusReferences: () => {},
  onClickOutPopup: () => {},
  align: 'left',
  hideWithOutsideClick: true,
  controlled: false
};

Popover.contextType = Context;

export default Popover;
